import { createSlice } from "@reduxjs/toolkit";
import { cloneBookAPI } from "../../api/cloneBooking";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const cloneBookSlice = createSlice({
  name: "cloneBook",
  initialState: data,
  reducers: {
   cloneBookSlice(state) {
      state.isLoading = true;
    },
   cloneBookSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    cloneBookSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    cloneBookSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const cloneBookHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(cloneBookAction.cloneBookSlice());
    const response: any = await cloneBookAPI(data);
    
    dispatch(cloneBookAction.cloneBookSliceSuccess(response));
  } catch (e: any) {
    dispatch(cloneBookAction.cloneBookSliceFailure(e?.response?.data));
  }
};
export default cloneBookSlice.reducer;
export const cloneBookAction = cloneBookSlice.actions;
